import { useState, useRef, useContext } from 'react';
import { RECAPTCHA_SITE_KEY } from "@/config.tsx";
import styles from './SearchByLaximoVinContainer.module.scss';
import { SearchVehicleByVinDataContext } from '../SearchVehicleByVinDataProvider';
import ReCAPTCHA from 'react-google-recaptcha';

// Импорты вынесенных компонентов
import LaximoVehicleContainer from '@/pages/SearchVehicle/LaximoVehicleContainer/LaximoVehicleContainer';
import { SearchVehicleDataContextType, SetSearchVehicleDataContextType } from '../types';
import { SearchInput } from './SearchInput';
import { SearchVehicleInfo } from './SearchVehicleInfo';

// Константа для reCAPTCHA v2 (если нужна)
const RECAPTCHA_V2_SITE_KEY = RECAPTCHA_SITE_KEY;

const SearchByLaximoVinContainer = () => {
	const { vin, carNumber, carNumberRegion, searchVehicle, vehicle } = useContext(SearchVehicleByVinDataContext) as SearchVehicleDataContextType;
	const { setVin } = useContext(SearchVehicleByVinDataContext) as SetSearchVehicleDataContextType;

	const [searchVIN, setSearchVIN] = useState(vin || '');
	const [showRecaptchaV2, setShowRecaptchaV2] = useState(false);

	const recaptchaRef = useRef<any>(null);
	const recaptchaV2Ref = useRef<any>(null);
	const searchActionRef = useRef<(() => void) | null>(null);

	const handleSearch = () => {
		//Отмена запроса, если параметры не изменились
		if (searchVIN === vin || searchVIN === carNumber || searchVIN.replace(" ", "").trim() === carNumber + carNumberRegion) return;

		if (isCaptchaVerified()) {
			setVin(searchVIN);
			// findSearchVehicle(searchVIN);
		} else {
			searchActionRef.current = () => setVin(searchVIN);
			// searchActionRef.current = () => findSearchVehicle(searchVIN);
			recaptchaRef.current?.execute();
		}
	};

	const handleRecaptchaVerify = (token: string | null) => {
		fetch('/verify-recaptcha', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ token })
		})
			.then(response => response.json())
			.then(data => {
				if (data.success) {
					if (searchActionRef.current) {
						searchActionRef.current();
					}
				} else {
					setShowRecaptchaV2(true);
				}
			})
			.catch(() => {
				alert('Verification failed. Please try again.');
			});
	};

	const handleRecaptchaV2Verify = (token: string | null) => {
		fetch('/verify-recaptcha', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ token, action: 'recaptcha_v2' })
		})
			.then(response => response.json())
			.then(data => {
				if (data.success) {
					setShowRecaptchaV2(false);
					if (searchActionRef.current) {
						searchActionRef.current();
					}
				} else {
					alert('reCAPTCHA v2 verification failed');
				}
			});
	};

	const isCaptchaVerified = () => {
		return document.cookie.split(';').some((item) => item.trim().startsWith('captcha_verified='));
	};

	return (
		<div>
			<div className={showRecaptchaV2 ? styles.blurred : ''}>
				<div className={styles.card}>
					<SearchInput
						searchVIN={searchVIN}
						setSearchVIN={setSearchVIN}
						handleSearch={handleSearch}
						carNumber={carNumber}
						carNumberRegion={carNumberRegion}
					/>
					<SearchVehicleInfo searchVehicle={searchVehicle} />
					<LaximoVehicleContainer vehicle={vehicle} />
					<ReCAPTCHA
						ref={recaptchaRef}
						sitekey={RECAPTCHA_SITE_KEY}
						size="invisible"
						onChange={handleRecaptchaVerify}
					/>
				</div>
			</div>
			{showRecaptchaV2 && (
				<div className={styles.recaptchaOverlay}>
					<div className={styles.recaptchaContainer}>
						<ReCAPTCHA
							ref={recaptchaV2Ref}
							sitekey={RECAPTCHA_V2_SITE_KEY}
							size="normal"
							onChange={handleRecaptchaV2Verify}
						/>
					</div>
				</div>
			)}
		</div>
	)
};

export default SearchByLaximoVinContainer;
